import TRANSACTIONS from '../actionTypes/transactions_actionType';
import originalMoment from "moment";
import { extendMoment } from "moment-range";
const moment = extendMoment(originalMoment);

const getLastMonthDateRange = () => {
  let start = moment().subtract(30, 'days')
  let end = moment()
  return {
    start:start,
    end:end
  }
}

const initialState = {
  query:{
    selectedDateRange:getLastMonthDateRange(),
    status:'all'
  }
}

const transactions = (state = initialState, action) => {
  switch (action.type) {
    case TRANSACTIONS.UPDATE_QUERIES_FOR_TRANSACTION:
      return {
        ...state,
        query: action.payload
      }
    case TRANSACTIONS.RESET_INITIAL_DATA:
      let newQuery = {
        status:'all'
      }
      newQuery['selectedDateRange'] = getLastMonthDateRange()
      return {
        ...state,
        query: newQuery
      }
    default:
      return { ...state }
  }
}

export default transactions
